export const UPDATE_DESCBLOCK_DATA = '@stencil/UPDATE_DESCBLOCK_DATA';
export const UPDATE_DESCBLOCK_INPUT = '@stencil/UPDATE_DESCBLOCK_INPUT';
export const UPDATE_HOTELS_PAYMENTS_DATA = '@stencil/UPDATE_HOTELS_PAYMENTS_DATA';
export const UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS =
  '@stencil/UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS';
export const UPDATE_USEGOCASH_STATUS = '@stencil/UPDATE_USEGOCASH_STATUS';
export const RESET_PAYMENTS_DATA = '@stencil/RESET_PAYMENTS_DATA';
export const UPDATE_DESCBLOCK_LOADING_STATUS = '@stencil/UPDATE_DESCBLOCK_LOADING_STATUS';
export const UPDATE_EARLYCHECKIN_STATUS = '@stencil/UPDATE_EARLYCHECKIN_STATUS';
export const UPDATE_COUNTRY_CODES = '@stencil/UPDATE_COUNTRY_CODES';
export const UPDATE_HOTELS_POLICY = '@stencil/UPDATE_HOTELS_POLICY';
export const RESET_REVIEW_PAGE_DATA = '@stencil/RESET_REVIEW_PAGE_DATA';
export const TOGGLE_AGREE_TNC = '@stencil/TOGGLE_AGREE_TNC';
export const UPDATE_DONATE_CHARITY_STATUS = '@stencil/UPDATE_DONATE_CHARITY_STATUS';
export const UPDATE_OFFERS_FROM_HERMES = '@stencil/UPDATE_OFFERS_FROM_HERMES';
export const UPDATE_ACTIVE_PAYMODE = 'UPDATE_ACTIVE_PAYMODE';
export const TOGGLE_POLICIES_MODAL = 'TOGGLE_POLICIES_MODAL';
